export default __webpack_public_path__ + "static/media/img10.b4e52b9b.png";